import { render, staticRenderFns } from "./TextsContainer.vue?vue&type=template&id=8c6f51cc&"
import script from "./TextsContainer.vue?vue&type=script&lang=js&"
export * from "./TextsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TextsContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports